import { onCLS, onFCP, onLCP, onTTFB, onINP } from "web-vitals";

const reportWebVitals = (onPerfEntry?: (metric: unknown) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    onCLS((metric) => onPerfEntry(metric));
    onFCP((metric) => onPerfEntry(metric));
    onLCP((metric) => onPerfEntry(metric));
    onTTFB((metric) => onPerfEntry(metric));
    onINP((metric) => onPerfEntry(metric));
  }
};

export default reportWebVitals;
